import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses, DropdownSelectOption } from '@paintscout/ui'
import { DropdownSelect } from '@paintscout/ui'

const useStyles = makeStyles<Theme, LeadSourceSelectorProps>(
  (_theme) => ({
    root: {}
  }),
  { name: 'LeadSourceSelector' }
)

export interface LeadSourceSelectorProps {
  classes?: StyleClasses<typeof useStyles>
  value: DropdownSelectOption
  sources: DropdownSelectOption[]
  className?: string
  disabled?: boolean
  label?: string
  onChange: (option: DropdownSelectOption) => any
}

function LeadSourceSelector(props: LeadSourceSelectorProps) {
  const classes = useStyles(props)
  const { disabled, sources = [], value, onChange, label } = props

  return (
    <div className={classes.root}>
      <DropdownSelect
        variant="single"
        disabled={disabled}
        name="source"
        label={label || 'Source'}
        placeholder={{
          selectPlaceholder: 'Select a source',
          plural: 'sources'
        }}
        fullWidth
        searchable
        value={value}
        onChange={onChange}
        hasUnselect
        options={sources}
        noOptionsMessage={sources.length !== 0 ? 'No options' : `You haven't created any lead sources`}
      />
    </div>
  )
}

export default LeadSourceSelector
